import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const HAS_SUBFOLDER_DESCRIPTIONS_QUERY_KEY = 'folders.hasSubfolderDescriptions';

export const useHasSubfolderDescriptions = ({ folderId, enabled = true }: { folderId?: string; enabled?: boolean }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [HAS_SUBFOLDER_DESCRIPTIONS_QUERY_KEY, { folderId, tenantId }],
    queryFn: () => {
      return folderId
        ? api.tenants.getFolderHasSubfolderDescriptions(tenantId, folderId)
        : api.tenants.getRootHasSubfolderDescriptions(tenantId);
    },
    enabled: enabled && !!tenantId,
  });

  return {
    hasDescriptions: data?.data?.hasDescriptions ?? false,
    isLoading,
    error,
  };
};
